import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { useTranslation, Trans } from 'react-i18next';
import { headerStates, urlApplicationRoot } from '/business/shared/util/Statics';
import getUserAuthedReportsSelector from '/business/shared/state/selectors/auth/getUserAuthedReportsSelector';
import HeaderDashboard from './dashboard/HeaderDashboard';
import HeaderStatic from './static/HeaderStatic';
import HeaderApplication from './application/HeaderApplication';
import HeaderSettings from './settings/HeaderSettings';
import StyledContainer from '/shared/styled/StyledContainer';
import StyledInner from '/shared/styled/StyledInner';
import StyledHeader from './__styled__/StyledHeader';
import StyledHeaderInner from './__styled__/StyledHeaderInner';
import HeaderLogo from '/business/shared/components/widgets/header/HeaderLogo';
import type { RootState } from '/business/shared/state/store';
import type { ReactNode } from 'react';

// import useAppContext from '/business/shared/hooks/useAppContext';

function HeaderInner() {
  const userFirstName = useSelector((state: RootState) => state.auth?.user?.account?.metadata?.firstName);
  const availableReports = useSelector(getUserAuthedReportsSelector);
  const { t } = useTranslation();
  const location = useLocation();
  const path = location.pathname;
  let headerState = headerStates.STATIC;
  let staticTitle: ReactNode = null;
  let subStaticTitle: ReactNode = null;
  let showStaticNav = false;
  if (path.startsWith(`/${urlApplicationRoot}-settings`)) {
    headerState = headerStates.SETTINGS;
  } else if (path.startsWith(`/${urlApplicationRoot}`)) {
    headerState = headerStates.APPLICATION;
  } else if (path.startsWith('/my-profile')) {
    showStaticNav = true;
  } else if (path.startsWith('/reporting')) {
    const reportCount = availableReports.countries.length + availableReports.region.length;
    showStaticNav = true;
    staticTitle = t('business:ReportsPage.title', 'Reports');
    subStaticTitle = t('business:ReportsPage.subTitle', {
      // Each region has access to '2 reports', so double the count
      reportAccessCount: reportCount * 2,
    });
  } else if (path === '/') {
    headerState = headerStates.DASHBOARD;
  }
  if (path === `/create-${urlApplicationRoot}`) {
    staticTitle = t('business:Dashboard.buttonCreateApplication', 'Create new application');
  } else if (path === `/create-${urlApplicationRoot}/success`) {
    staticTitle = t('business:Dashboard.createdApplicationTitle');
  } else if (path === '/my-profile') {
    // @i18n: Welcome Alex
    staticTitle = (
      <Trans
        i18nKey="business:ProfilePage.title"
        values={{
          name: userFirstName,
        }}
        components={{
          1: <strong />,
        }}
      />
    );
    subStaticTitle = (
      <Trans
        i18nKey="business:ProfilePage.subTitle"
        components={{
          1: <strong />,
        }}
      />
    );
  }
  return (
    <StyledHeaderInner>
      {headerState === headerStates.DASHBOARD && <HeaderDashboard />}
      {headerState === headerStates.APPLICATION && <HeaderApplication />}
      {headerState === headerStates.SETTINGS && <HeaderSettings />}
      {headerState === headerStates.STATIC && (
        <HeaderStatic showNav={showStaticNav} title={staticTitle} subTitle={subStaticTitle} />
      )}
    </StyledHeaderInner>
  );
}
function Header() {
  return (
    <StyledHeader>
      <HeaderLogo />
      <StyledContainer $centred>
        <StyledInner $business>
          <HeaderInner />
        </StyledInner>
      </StyledContainer>
    </StyledHeader>
  );
}
export default Header;
